export default __webpack_public_path__ + "static/media/category-consulting.be66cd26.jpg";